import { Component } from '@angular/core';

import { MainHeaderFigmaComponent } from '../main-header-figma/main-header-figma.component';
import { TopBarFigmaComponent } from '../top-bar-figma/top-bar-figma.component';

@Component({
    selector: 'app-header-figma-complete',
    templateUrl: './header-figma-complete.component.html',
    standalone: true,
    imports: [MainHeaderFigmaComponent, TopBarFigmaComponent]
})
export class HeaderFigmaCompleteComponent {
  // Composant conteneur pour les deux barres Figma
}